import { sanitizeResumeText } from "../../../../server/sanitizeResumeText";

let pdfJsReady = false;

const loadPdfJs = async () => {
  const pdfjs = await import("pdfjs-dist/legacy/build/pdf");

  if (!pdfJsReady) {
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;
    pdfJsReady = true;
  }

  return pdfjs.getDocument;
};

const extractTextFromPdfBytes = async (bytes) => {
  const getDocument = await loadPdfJs();
  const pdfDoc = await getDocument({
    data: bytes,
    useSystemFonts: true,
    disableFontFace: true,
  }).promise;

  const pages = [];
  for (let pageNumber = 1; pageNumber <= pdfDoc.numPages; pageNumber += 1) {
    const page = await pdfDoc.getPage(pageNumber);
    const textContent = await page.getTextContent();
    const pageText = textContent.items.map((item) => item.str || "").join(" ");
    pages.push(pageText);
  }

  return sanitizeResumeText(pages.join("\n\n"));
};

const extractTextFromDocxBytes = async (bytes) => {
  const mammoth = await import("mammoth");
  const result = await mammoth.extractRawText({
    arrayBuffer: bytes.buffer.slice(
      bytes.byteOffset,
      bytes.byteOffset + bytes.byteLength
    ),
  });
  return sanitizeResumeText(result.value || "");
};

/**
 * Browser fallback when /api/parse-pdf is unavailable (static production hosting).
 */
export const parseResumeClientSide = async (resumeUrl) => {
  const response = await fetch(resumeUrl);
  if (!response.ok) {
    throw new Error(`Failed to fetch resume (${response.status})`);
  }

  const buffer = await response.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  const fileType = resumeUrl.toLowerCase().endsWith(".pdf")
    ? "pdf"
    : "docx";

  let text = "";
  if (fileType === "pdf") {
    text = await extractTextFromPdfBytes(bytes);
  } else {
    text = await extractTextFromDocxBytes(bytes);
  }

  if (!text) {
    throw new Error("Could not extract resume text");
  }

  return text;
};
